import React from "react";
import styled, { DefaultTheme } from "styled-components";

import { PropsWithChildren } from 'react';
import { assertNever } from "../../../../amorg-common";

type CustomFormFieldCardProps = {
    paddingTop?: number,
    onClick?: () => void,
}

type CardColors = 'attention' | 'light';


type CustomFormFieldCardColoredProps = {
    variant?: CardColors;
}

export function CustomFormFieldCardColored(props:PropsWithChildren<CustomFormFieldCardColoredProps>):JSX.Element
{
    return <StyledCardColored variant={props.variant}>{props.children}</StyledCardColored>
}


export function CustomFormFieldCard(props:PropsWithChildren<CustomFormFieldCardProps>):JSX.Element
{
    
    return <StyledFatBorderCard {...props}>{props.children}</StyledFatBorderCard>
    
}

const baseCard = styled.div<{marginTop?:number, marginBottom?:number, paddingNone?: boolean, onClick?: () => void, paddingTop?:number}>`
    margin-top:${props => props.marginTop===undefined ? '0px' : `${props.marginTop}px`};
    margin-bottom:${props => props.marginBottom===undefined ? '0px' : `${props.marginBottom}px`};
    transition: all 0.2s ease-in;
    padding:${props => props.paddingNone ? '0' : '0 1rem 1rem 1rem'};
    ${props => props.paddingTop && `padding-top: ${props.paddingTop}px;`}
    border-radius: 4px;   


    &:hover{
        background-color: ${ props => props.onClick && props.theme.colors.customForm.answer.formFieldCard.body.background.hover };
        cursor: ${ props => props.onClick && "pointer" };
    }

    &:active{
        cursor: ${ props => props.onClick && "pointer" };
    }

    
    & .list-menu li button div:hover{
        ${ props => props.onClick && "cursor: pointer;" }
    }
`;



export const StyledFatBorderCard = styled(baseCard)`
    background-color: ${props => props.theme.colors.customForm.answer.formFieldCard.body.background.default};
    border:2px solid ${props => props.theme.colors.customForm.answer.formFieldCard.border};
`;


const changeBackgroundColor = (variant: CardColors, theme:DefaultTheme): string => {
    switch (variant) {
        case "attention":
            return theme.colors.customForm.answer.formFieldCard.body.background.attention;
        case "light":
            return theme.colors.customForm.answer.formFieldCard.body.background.default;

        default: assertNever(variant);
    }
}


export const StyledCardColored = styled.div<{variant?: CardColors}>`
    background-color: ${props => changeBackgroundColor(props.variant, props.theme)};
    border:1px solid ${props => changeBackgroundColor(props.variant, props.theme)};
    padding: 1rem;
    border-radius: 4px;
`;